import { useEffect, useState } from "react";
import api from "../../js/api";
import Select from "../../components/Select/Select";

export default function Ollama() {

    const [models, setModels] = useState([]);
    const [model, setModel] = useState(null);

    useEffect(() => {
        api.get('/ollama/tags').then(response => {
            console.log(response.models)
            setModels(response.models);
        });
    }, []);

    return (
        <div id="ollama">
            <div className="centered-container flex flex-column gap">
                <h1>LLM</h1>
                {models && models.length &&
                    <Select
                        title="Select a model"
                        options={models.map(m => m.name)}
                        onChange={(model) => {
                            console.log("Selected model:", model);
                            setModel(model);
                        }}
                    />
                }
                {model &&
                    <div>
                        Selected model: {model}
                    </div>
                }
                {model && 
                    <textarea className="input" rows={5} cols={50} placeholder="Type your prompt here..." />
                }
            </div>
        </div>
    );
}